/* eslint-disable @typescript-eslint/camelcase */
export type StepType = 'your_consent' | 'additional_options' | 'comprehension';

export type Step = {
  type: StepType;
  name: string; // Name of the step as it appears in the stepper.
};

const DefaultSteps = {
  your_consent: {
    type: 'your_consent',
    name: 'Your consent'
  },
  additional_options: {
    type: 'additional_options',
    name: 'Additional options'
  },
  comprehension: {
    type: 'comprehension',
    name: 'Comprehension'
  }
};

const NoOptionsSteps = {
  your_consent: {
    type: 'your_consent',
    name: 'Your consent'
  },
  comprehension: {
    type: 'comprehension',
    name: 'Comprehension'
  }
};

export type Data = {
  steps: { [key in StepType]: Step };
  patientConsentId: string;
  selectedStep: StepType;
};

const INITIAL_DATA_STATE = {
  steps: DefaultSteps,
  patientConsentId: '',
  selectedStep: 'your_consent'
};

export default class ConsentStateManager {
  onDataChange: (data: Data) => void;

  // @ts-ignore
  data: Data = INITIAL_DATA_STATE;

  constructor(onDataChange: (data: Data) => void) {
    this.onDataChange = onDataChange;
  }

  setNoAdditionalOptions() {
    this.updateData({
      ...this.data,
      // @ts-ignore
      steps: NoOptionsSteps
    });
  }

  setNoComprehensionQuestions() {
    const { steps } = this.data;
    this.updateData({
      ...this.data,
      steps: {
        ...steps,
        comprehension: {
          type: 'comprehension',
          name: ''
        }
      }
    });
  }

  setUserDidAgreeToConsent(patientConsentId: string) {
    // if no additional options, skip straight to comprehension q's
    const secondStep = this.data.steps['additional_options'] || this.data.steps['comprehension'];
    this.updateData({
      ...this.data,
      patientConsentId,
      selectedStep: secondStep.type
    });
  }

  setUserDidCompleteConsentDecisions() {
    this.updateData({
      ...this.data,
      selectedStep: 'comprehension'
    });
  }

  updateData(data: Data) {
    this.data = data;
    this.onDataChange(this.data);
  }

  stepAtIndex(index: number): Step {
    const keyForIndex = Object.keys(this.data.steps)[index];
    // @ts-ignore
    return this.data.steps[keyForIndex];
  }

  goBackToStep(step: StepType) {
    this.updateData({
      ...this.data,
      selectedStep: step
    });
  }
}
